import axios from 'axios'

class BillingService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
   * @author Jorge Perales
   * @description Get the billing summary for a given year/month: current-month token and cost
   * usage vs. their limits, annual token/cost usage vs. limits, and token distribution by model
   * @param {String} year
   * @param {String} month
   * @param {String} token
   * @returns {Object}
   * @memberof BillingService
   */
  async getBillingSummary(year, month, token) {
    const response = await axios.get(`${this.apiUrl}/billing-summary-passthrough?year=${year}&month=${month}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }

  /**
   * @author Jorge Perales
   * @description Get token/cost consumption per month for a given year
   * @param {String} year
   * @param {String} token
   * @returns {Object}
   * @memberof BillingService
   */
  async getBillingMonthlyConsumption(year, token) {
    const response = await axios.get(`${this.apiUrl}/billing-monthly-consumption-passthrough?year=${year}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }

  /**
   * @author Jorge Perales
   * @description Get paginated billing/invoice history
   * @param {Number} page
   * @param {Number} pageSize
   * @param {String} token
   * @returns {Object}
   * @memberof BillingService
   */
  async getBillingInvoices(page, pageSize, token) {
    const response = await axios.get(`${this.apiUrl}/billing-invoices-passthrough?page=${page}&pageSize=${pageSize}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }

  /**
   * @author Jorge Perales
   * @description Get token/cost usage per model for the current billing cycle (contract lifetime)
   * @param {String} token
   * @returns {Object}
   * @memberof BillingService
   */
  async getBillingCycleModelUsage(token) {
    const response = await axios.get(`${this.apiUrl}/billing-cycle-model-usage-passthrough`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }

  /**
   * @author Jorge Perales
   * @description Get token/cost usage per bot (assistant) for the current billing cycle (contract lifetime)
   * @param {String} token
   * @returns {Object}
   * @memberof BillingService
   */
  async getBillingCycleBotUsage(token) {
    const response = await axios.get(`${this.apiUrl}/billing-cycle-bot-usage-passthrough`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }
}

export { BillingService as default }
